export default __webpack_public_path__ + "static/media/IMG_2137.9ab56b69.JPG";